/**
 * If we are in a screen size smaller than the arrows container
 * this will scroll us to the currently active arrow
 * @return {void}
 */
export function checkIfWeNeedToScroll(): void {  
  const arrowWrapper = document.querySelector('.arrow-steps-wrapper') as HTMLElement | null
  const activeArrow = document.querySelector('.arrow-step.active') as HTMLElement | null

  if (arrowWrapper && activeArrow) {
    arrowWrapper.scrollLeft = activeArrow.offsetLeft - 10
  }
}

export function formatDate(dateSource: string | number | Date | null | undefined, locale: Intl.LocalesArgument, addTime: boolean = true) {
  if (!dateSource) {
    return ''
  }

  let dateFormatOptions: Intl.DateTimeFormatOptions = {
    month : 'short',
    day   : 'numeric',
  }

  if (addTime) {
    dateFormatOptions = {
      ...dateFormatOptions,
      hour   : '2-digit',
      minute : '2-digit',
      hour12 : true,
    }
  }

  return new Date(dateSource).toLocaleString(locale, dateFormatOptions)
}

const stepsArray = [
  'received',
  'processed',
  'packed',
  'transferred',
  'prepared',
  'quality',
  'shipped',
  'estimated',
  'delivered',
] as const


export type StepKey = typeof stepsArray[number]
type VisibilityGroup = '*' | 'regular' | 'regular-eu' | 'consolidated-eu-us' | 'split-eu' | 'split-us'

interface ShippingStatus {
  title: string
  dateKey: string
  icon: string
  completedArray: StepKey[]
  visibility: VisibilityGroup[]
}

export const shippingStatuses: Record<StepKey, ShippingStatus> = {
  received: {
    title          : 'Received',
    dateKey        : 'receivedDate',
    icon           : 'rss/received',
    completedArray : [],
    visibility     : ['*'],
  },
  processed: {
    title          : 'Processed',
    dateKey        : 'processedDate',
    icon           : 'rss/processed',
    completedArray : stepsArray.slice(0, 1),
    visibility     : ['*'],
  },
  packed: {
    title          : 'Picked',
    dateKey        : 'packedDate',
    icon           : 'rss/picked',
    completedArray : stepsArray.slice(0, 2),
    visibility     : ['regular'],
  },
  transferred: {
    title          : 'In Transit from U.S.',
    dateKey        : 'transferredDate',
    icon           : 'rss/transferred',
    completedArray : stepsArray.slice(0, 3),
    visibility     : ['consolidated-eu-us', 'split-us'],
  },
  prepared: {
    title          : 'Preparing',
    dateKey        : 'preparedDate',
    icon           : 'rss/picked',
    completedArray : stepsArray.slice(0, 4),
    visibility     : ['regular-eu', 'consolidated-eu-us', 'split-eu', 'split-us'],
  },
  quality: {
    title          : 'Quality Checked',
    dateKey        : 'qualityDate',
    icon           : 'rss/qc',
    completedArray : stepsArray.slice(0, 5),
    visibility     : ['regular'],
  },
  shipped: {
    title          : 'Shipped',
    dateKey        : 'pickUpDate',
    icon           : 'rss/shipped',
    completedArray : stepsArray.slice(0, 6),
    visibility     : ['*'],
  },
  estimated: {
    title          : '',
    dateKey        : 'estimatedDeliveryDateLabel',
    icon           : 'rss/shipped',
    completedArray : stepsArray.slice(0, 7),
    visibility     : [],
  },
  delivered: {
    title          : '',
    dateKey        : 'deliveryDate',
    icon           : 'rss/delivered',
    completedArray : stepsArray.slice(0, 8),
    visibility     : ['*'],
  },
}
